import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo/head";
import { resolveRouteMeta } from "@/lib/seo/routeMeta";
import RubenHeroResults from "@/pages/lp/RubenHeroResults";

const TITLE = "Your Hero Stack Results — Home Approach";
const DESC = "Your grant Stack and Hero Benefits Alliance layer, with next steps from Ruben Nazario.";

export const Route = createFileRoute("/lp/ruben-hero/results")({
  head: () =>
    buildHead({
      ...resolveRouteMeta("/lp/ruben-hero/results"),
      title: TITLE,
      description: DESC,
      ogTitle: TITLE,
      ogDescription: DESC,
      noIndex: true,
    }),
  component: RubenHeroResults,
});
